module.exports = __webpack_public_path__ + "img/thumb-up.ee68a75c.svg";